import { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';
import { BrowserRouter } from 'react-router-dom';

import App from './app';

if (import.meta.env.VITE_SENTRY_ENABLE === 'true') {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 1.0,
    environment: import.meta.env.VITE_SENTRY_ENV,
  });
}

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <BrowserRouter>
    <Suspense>
      <Sentry.ErrorBoundary>
        <App />
      </Sentry.ErrorBoundary>
    </Suspense>
  </BrowserRouter>
);
